<template>
  <div class="main-container">
    <h1>{{ getMessage('MSG_OCURRIO_ERROR') }}</h1>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      redirectionTime: 5000
    }
  },
  computed: {
    ...mapGetters('GeneralAR', ['getMessage'])
  },
  mounted: function () {
    this.backHome()
  },
  methods: {
    backHome: function () {
      var vm = this
      setTimeout(function () {
        vm.$router.push({ name: 'TotemHome' })
      }, vm.redirectionTime)
    }
  }
}
</script>
<style lang="scss" scoped>
  @import './styles.scss';
</style>
